// extracted by mini-css-extract-plugin
export default {"wrapper":"Rating_wrapper__DUmyZ","title":"Rating_title__Mn6nb","titleText":"Rating_titleText__u1IkY","vector":"Rating_vector__HK3c9","menuSwiper":"Rating_menuSwiper__tEFBQ"};